{
  "version": 1,
  "asset_id": "7cc63d04-3fa1-430f-96c3-0f1ab2081d2a",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/7cc63d04-3fa1-430f-96c3-0f1ab2081d2a/blog-default-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/7cc63d04-3fa1-430f-96c3-0f1ab2081d2a/blog-default-640.avif",
  "original_filename": "blog-default-640.avif",
  "size": 22219,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:25:51Z"
}
